export default "__VITE_ASSET__9d717382__"